<template>
  <div class="footer">
    <div class="ft-content">
      <div class="con-left">
        <div class="con-right">
          <h3>咨询热线</h3>
          <h2 style="margin-top: 12px;">0375-6033699</h2>
          <p>邮箱：ciicpservice@trgroup.cn</p>
          <!-- <p>微信公众号：trxxkj</p> -->
          <div style="display: flex;">
            <div>
              <img
                src="../assets/image/code.jpg"
                alt=""
              />
              <p style="text-align: center;">天 瑞 信 科</p>
            </div>
            <!-- <div style="margin-left: 20px; text-align: center;">
              <img
                src="../assets/image/otherCode.jpg"
                alt=""
              />
              <p style="letter-spacing:-0.5px">天信工业互联网平台</p>
            </div> -->

          </div>

        </div>
        <div class="con-main">
          <div class="item">
            <h3>产品及服务</h3>
            <ul>
              <li
                class="over"
                v-for="item in productList"
                :key="item.name"
                @click="goToFangAnFn('/product.html#/detail?id=',item.id)"
              >{{item.name}}</li>
            </ul>
          </div>
          <div class="item">
            <h3>行业解决方案</h3>
            <div>
              <ul>
                <li
                  class="over"
                  v-for="item in fangAn1"
                  :key="item.name"
                  @click="goToFangAnFn('/product.html#/planDetail?id=',item.id)"
                >{{item.name}}</li>
              </ul>

            </div>
          </div>
          <div class="item">
            <h3>关于我们</h3>
            <ul>
              <li
                class="over"
                v-for="item in aboutData"
                :key="item.name"
                @click="goToFangAnFn('/about.html#',item.url)"
              >{{item.name}}</li>

              <!-- <li>公司简介</li>
            <li>联系我们</li>
            <li>人才招聘</li> -->
            </ul>
          </div>
          <!-- <div>
          <h3>开发平台</h3>
          <ul> -->
          <!-- <li v-for="item in kaiFaData" :key="item.name"  @click="goToFangAnFn('/developer.html#',item.url)">{{item.name}}</li> -->
          <!-- <li>低代码开发者平台</li>
            <li>大数据管理平台</li>
            <li>OT服务平台</li> -->
          <!-- </ul>
        </div> -->
          <div class="item">
            <h3>友情链接</h3>
            <ul>
              <li
                class="over"
                v-for="item in lianJieData"
                :key="item.name"
              ><a
                  :href="item.url"
                  target="_blank"
                  style="font-family: Microsoft YaHei;"
                >{{item.name}}</a></li>
              <!-- <li>工业互联网产业联盟</li>
            <li>华为云</li>
            <li>阿里云</li> -->
            </ul>
          </div>

        </div>
      </div>
    </div>
    <div class="ft-address">
      <div style="display: flex;justify-content: center;">
        <!-- <img
          src="../assets/image/company.svg"
          alt=""
        /> -->
        <!-- <div class="company-name">天瑞信科（河南）数字科技有限公司</div> -->
      </div>
      <div class="ad-ruzhou">
        地址：河南自贸试验区郑州片区（郑东）祥盛街8号附1号福晟国际3号楼11层
      </div>
      <div class="ad-ruzhou">
        <a href="https://beian.miit.gov.cn">豫ICP备16000166号-2</a> 版权所有：天瑞信科（河南）数字科技有限公司 Copyright ©
        www.ciicp.com All Rights Reserved
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fangAn1: [],
      productList: [],
      fangAn2: [
        { name: "黑色金属制造业产成品质量追溯解决方案", url: "/blackMetal" },
        { name: "工业安全环保解决方案", url: "/safety" },
        { name: "水泥行业智能化节能降碳解决方案", url: "/shuiNiZN" },
        { name: "能源行业原煤多式联运解决方案", url: "/newEnergy" },
        { name: "集团企业生产运营集控中心解决方案", url: "/duoYuanHua" },
      ],
      aboutData: [
        { name: "公司简介", url: "/about" },
        { name: "联系我们", url: "/ContactUs" },
        { name: "人才招聘", url: "/recruit" },
      ],
      kaiFaData: [
        { name: "低代码开发者平台", url: "/fewCode" },
        { name: "大数据管理平台", url: "/passManage" },
        { name: "OT服务平台", url: "/txOt" },
      ],
      lianJieData: [
        { name: "工业和信息化部", url: "https://www.miit.gov.cn/" },
        { name: "河南省工信厅", url: "https://gxt.henan.gov.cn/" },
        { name: "中国信息通信研究院", url: "http://www.caict.ac.cn/" },
        { name: "中国工业互联网研究院", url: "https://www.china-aii.com/" },

        {
          name: "国家工业信息安全发展研究中心",
          url: "https://www.cics-cert.org.cn/",
        },

        { name: "天瑞集团", url: "http://www.tianruigroup.cn/" },
      ],
    };
  },
  mounted() {
    this.getMainMenu();
  },
  methods: {
    async getMainMenu() {
      let res = await this.API.home.getMainMenu();
      if (res.code == 200) {
        res.data.productList.forEach((ele, index) => {
          if (index <= 5) {
            this.productList.push({
              ...ele,
              url: "",
            });
          }
        });

        res.data.schemeList.forEach((ele, index) => {
          if (index <= 5) {
            this.fangAn1.push({
              ...ele,
              url: "",
            });
          }
        });
        res.data.caseList.forEach((ele) => {});
      }
    },
    goToFangAnFn(htm, url) {
      window.location.href = `${htm}${url}`;
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.over {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.footer {
  /* height: 126px; */
  width: 100%;
  // border-top: 1px solid rgba(0, 0, 0, 0.1);
  // padding: 35px 0 35px;
}
.ft-content {
  // height: 320px;
  background: #191c22;
  display: flex;
  padding: 50px 0px;
  flex-direction: row;
}
.con-left {
  width: 1200px;
  margin: auto;
  display: flex;
  flex-direction: row;
  // margin-left: 9%;
  // gap: 70px;
  // background: lemonchiffon;
  div {
    min-width: 64px;
    // margin-right: 30px;
    // margin-left: 12%;
    /* flex: 1; */
    h3 {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;

      color: #e7f0fc;
    }
    ul {
      li {
        cursor: pointer;
        margin-top: 16px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #a5abb0;
        a {
          color: #a5abb0;
        }
      }
    }
  }
}
.con-main {
  display: flex;
  flex: 1;
  justify-content: space-between;
  .item {
    max-width: 200px;
  }
}
.con-right {
  // margin-left: 3%;
  width: 24%;
  p {
    margin-top: 12px;
    font-size: 14px;
    color: #e7f0fc;
    font-family: Microsoft YaHei;
    margin-left: 0px;
  }
  img {
    width: 112px;
    height: 112px;
    margin-top: 20px;
    margin-left: 0px;
  }
  h2 {
    font-size: 32px;
    color: #e7f0fc;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }
}
.ft-address {
  padding: 30px 160px;
  text-align: center;
  // height: 140px;
  background: #000000;
}
.ad-ruzhou {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: #d6d6d6;
  margin-top: 17px;
  a {
    color: #d6d6d6;
  }
}
</style>
